import { CupraModelVersionModel } from "./cupramodelversion";
import { CupraBudgetOperationModel } from "./cuprabudgetoperation";
import { CupraBudgetPiezaDesgasteModel } from "./cuprabudgetpiezadesgaste";
export class CupraBudgetModel {
  IdBudget: string;
  IdStatus: number;
  IdModel: string;
  IdVersion: string;
  IdPitstop?: number;
  Pitstop: string;
  PitstopKm?: number;
  PitstopMonths?: number;
  IdDistributor: number | null;
  Distributor: string;
  IdProvince: number | null;
  Province: string;
  BudgetCode: string;
  Matricula: string;
  Bastidor: string;
  Email: string;
  Km: number | null = 1000;
  Months: number | null;
  ModelVersion: CupraModelVersionModel;
  BudgetOperations: CupraBudgetOperationModel[];
  BudgetPiezaDesgaste: CupraBudgetPiezaDesgasteModel[];
  Workforce?: number;
  Tax?: number;
  ShowCupraCare: boolean;
  CcName: string;
  CcSurname: string;
  CcEmail: string;
  CcPhone?: number;
  CcIdDistributor?: number;
  CcSubscribed: boolean;
  CcEmrSubscribed: boolean;
  CcDate: boolean;
  BudgetPrice: number;
  HasMaintenance: boolean;
  DiscountA: number;
  DiscountB: number;
  DiscountC: number;
  CupraCarePrice: number;
  FirstTime: boolean;
  DistributorAddress: string;
  DistributorCity: string;
  DistributorCp: string;
  DistributorPhone: string;
  CreationDate: Date;
}
